export enum PERMISSION_NAMES {
    super_user = 'Super User',
    finance = 'Finance',
    copyright = 'Copyright',
    internal_user = 'Internal User',
}
